import { OnboardingWizard } from '@/components/onboarding/OnboardingWizard';
import { ValidationReport } from '@/components/onboarding/ValidationReport';

export function OnboardingPage() {
  return <OnboardingWizard />;
}

export function ValidationReportPage() {
  return <ValidationReport />;
}
